export default __webpack_public_path__ + "static/media/development.17d1a616.jpg";